<template>

  <svg
    t="1639131170680"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3987"
    width="64"
    height="64"
  ><path d="M479.04101562 169.2265625h65.91796876v672.36328125H479.04101562z" p-id="3988" /><path d="M305.67675781 416.41894531l-45.48339843-44.82421875L512 119.78808594l251.80664063 251.80664062-45.48339844 44.82421875L512 210.09570312zM90.125 841.58984375h843.75v65.91796875H90.125zM90.125 604.28515625h329.58984375v65.91796875H90.125zM604.28515625 604.28515625h329.58984375v65.91796875H604.28515625z" p-id="3989" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconMoveUp',
} as DefineComponent
</script>